
import { defineComponent, ref } from "vue";
import { PlusOutlined, MinusOutlined, InfoCircleOutlined } from '@ant-design/icons-vue';
import alertTips from "./alertTips.vue"
export default defineComponent({
    components: { PlusOutlined, MinusOutlined, InfoCircleOutlined, alertTips },
    props: {
        name: {
            required: true,
            type: String,
        },
        //修改数据
        value: {
            required: false,
            type: Number,
        },
        //仅作展示数据用
        showValue: {
            require: true,
            type: Number
        },

        //最大值
        maxValue: {
            required: false,
            type: Number,
        },
        minValue: {
            required: false,
            type: Number,
        },
        //是否可以为负数
        isMinus: {
            required: false,
            type: Boolean,
            default: false,
        },
        //标记 用于修改之后返回的标记
        sign: {
            required: true,
            type: String,
        },
        //是否可以修改 true表示不可修改
        disable: {
            required: false,
            type: Boolean,
            default: true,
        },
        //是否允许为空
        allowNegative: {
            required: false,
            type: Boolean,
            default: true,
        },
        //显示备注图标
        iconShow: {
            required: false,
            type: Boolean,
            default: false,
        },
        //工单系数显示
        tipsShow: {
            required: false,
            type: Boolean,
            default: false,
        },
        tipsValue: {
            required: false,
            type: Number,
        },
        explain: {
            required: false,
            type: String,
        },
        // 来料数
        preProcedureOutQty: {
            required: false,
            type: Number,
        }
    },
    emits: {
        //配置字段回调
        onChangeValue: (sign: string, newValue: number) => {
            return true;
        },
    },
    watch: {
        value(newName, oldName) {
            this.count = newName
        },
    },
    setup(props: any, ctx: any) {
        //获取当前选中的key
        const count = ref(props.value);
        //循环时间
        let loopTime = ref<number>(0);
        let timer = ref<number>(0);
        //循环定时器
        let loop = ref(undefined);
        const goTouch = (e, state: string) => {
            timer.value += 1
            loop.value = setInterval(() => {
                timer.value += 1
                if (state === "increase") {
                    count.value = Number(count.value) + 10;
                    //不能大于等于某个值
                    if (props.maxValue || props.maxValue === 0) {
                        if (count.value >= props.maxValue) {
                            count.value = props.maxValue
                        }
                    }
                } else {
                    count.value = Number(count.value) <= 0 ? 0 : Number(count.value) - 10 <= 0 ? Number(count.value) - 1 : Number(count.value) - 10;
                    //不允许为负数
                    //     if (!(props.allowNegative || count.value > 0)) {
                    //         count.value = 0
                    //     }
                    //不能小于等于某个值
                    if (props.minValue) {
                        if (count.value <= props.minValue) {
                            count.value = props.minValue
                        }
                    }
                }
                ctx.emit('onChangeValue', props.sign, Number(count.value))
                //执行长按事件
            }, 500);
            return false
        }
        //touchend事件
        const outTouch = (e, state: string) => {
            restLoop()
            if (timer.value != 0) {
                //执行单次点击事件
                if (state === "increase") {
                    count.value = Number(count.value) + 1;
                    //不能大于等于某个值
                    if (props.maxValue || props.maxValue === 0) {
                        if (count.value >= props.maxValue) {
                            count.value = props.maxValue
                        }
                    }
                } else {
                    count.value = Number(count.value) <= 0 ? 0 : Number(count.value) - 1;
                    //不能小于等于某个值
                    if (props.minValue) {
                        if (count.value <= props.minValue) {
                            count.value = props.minValue
                        }
                    }
                }
                ctx.emit('onChangeValue', props.sign, Number(count.value))
            }
            return false
        }
        const restLoop = () => {
            // clearTimeout(loop.value);
            clearInterval(loop.value)
        }
        const Touchmove = () => {
            restLoop()
        }

        return {
            count,
            outTouch,
            restLoop,
            Touchmove,
            goTouch,
        };
    },
});
